/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserLastActivityRequest { 
    /**
     * pokud je fk_user_id string/uuid, uprav zde; nyní předpokládáme integer ID uživatele
     */
    exUid: number;
}

